<template>
    <div>
        <b-table bordered no-local-sorting responsive
                 :busy="isBusy"
                 :items="items"
                 :fields="fields"
                 :per-page="0"
                 :sort-by.sync="sortBy"
                 @row-selected="rowSelected"
                 @head-clicked="headClicked">
            <template slot="actions" slot-scope="row">
                <b-button variant="primary" class="mr-2" size="sm"
                          @click="$router.push({ name: showRoute, params: { id: row.item.id } })">Bekijk
                </b-button>
                <b-button variant="danger" size="sm" @click="openDeleteModal(row.item)" v-if="row.item.links.destroy">Verwijder</b-button>
            </template>
            <template v-for="field in customFields" :slot="field.key" slot-scope="row">
                <component :is="field.field" :meta="field.meta" v-model="row" :key="'row-' + row.item.id + '-column-' + field.key"/>
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-pagination v-if="totalItems" size="md" v-model="currentPageNumber" :total-rows="totalItems" :per-page="currentPerPage" :disabled="isBusy"></b-pagination>
            </b-col>
            <b-col class="text-right align-middle">
                <i>{{ currentPerPage }} van de {{ totalItems }} items in totaal</i>
            </b-col>
        </b-row>
        <b-modal id="delete-object" ref="delete-object" title="Verwijder object" v-if="deletable">
            <p class="my-4">
                Weet je zeker dat je het object <strong>"{{deletable.resource_name}}"</strong> wilt verwijderen? Deze
                actie is onomkeerbaar.
            </p>
            <template slot="modal-footer">
                <b-button @click="hideDeleteModal">Nee</b-button>
                <b-button variant="danger" @click="deleteItem">Ja, verwijder</b-button>
            </template>
        </b-modal>
<!--      <div class="loading" v-if="this.isBusy">Loading&#8230;</div>-->
    </div>
</template>

<script>
    import {deleteItem, getData} from "../api";

    let timer = null;

    export default {
        props: {value: {}, endpoint: {}, showRoute: {}},

        data() {
            return {
                isBusy: false,
                items: [],
                fields: [],
                filters: [],
                actions: [],
                sortBy: undefined,
                sortDir: 'asc',
                totalItems: undefined,
                currentPage: 1,
                perPage: undefined,
                deletable: [],
                selected: [],
            };
        },
        computed: {
            customFields(){
                return this.fields.filter(filter => filter.field !== 'field-text' && filter.key !== 'actions');
            },
            currentPerPage: {
              get: function () {
                return this.perPage > this.totalItems ? this.totalItems : this.perPage;
              },
              set: function(value) {
                this.perPage = value;
              }
            },
            currentPageNumber: {
              get: function () {
                return this.currentPage;
              },
              set: function (value) {
                this.currentPage = value;
              }
            }
        },
        methods: {
            async getItems() {
              this.isBusy = true;

              return await this.call().then(async response => {
                this.filters = response.filters;
                this.actions = response.actions;
                this.items = response.data;
                this.fields = response.fields;
                this.perPage = response.per_page;
                this.totalItems = response.total;
                this.currentPage = response.current_page;

                this.syncData();
                await this.storeTableSettings({currentPage: this.currentPage});

                this.isBusy = false;

              }).catch(error => {
                console.log('Error: ', error);
                throw error;
              });
            },

            syncData() {
                this.$emit('input', this.filters);
                this.$emit('inputActions', this.actions);
            },

            async call() {
                let params = {
                    page: this.currentPage,
                    sort_by: this.sortBy,
                    sort_direction: this.sortDir,
                };

                this.value.forEach(filter => {
                    params[filter.name] = filter.value;
                });

                const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

                return await getData(`${this.endpoint}?${queryString}`)
                    .then(response => response.data);
            },

            openDeleteModal(item) {
                this.deletable = item;
                this.$refs['delete-object'].show()
            },
            hideDeleteModal() {
                this.$refs['delete-object'].hide();
            },
            async deleteItem() {
                this.isBusy = true;
                this.hideDeleteModal();
                await deleteItem(this.deletable.links.destroy, true);
                this.getItems();
                this.isBusy = false;
            },
            headClicked: function (key, field) {
                this.sortBy = field.sort_key;
                this.sortDir = field.sort === 'asc' ? 'desc' : 'asc';
                this.getItems();
            },
            rowSelected: function (items) {
                this.selected = items;
            },
            storeTableSettings(value) {
                const result = new Promise((resolve, reject) => {
                  const namespace = this.endpoint;

                  localStorage.setItem(`${namespace}-settings`, JSON.stringify(value));

                  resolve();
                });

                return result;
            },
            autoLoadTableSettings() {
                const result = new Promise((resolve, reject) => {
                  const namespace = this.endpoint;

                  const settings = localStorage.getItem(`${namespace}-settings`);

                  if (settings) {
                      const parsed = JSON.parse(settings);

                      if (parsed && parsed.currentPage) {
                        this.currentPage = parsed.currentPage;
                      }
                  }
                  resolve();
                });

                return result;
            },
        },
        beforeMount() {
            this.autoLoadTableSettings().then(async () => {
              await this.getItems();
            });
        },
        watch: {
            currentPage: {
                handler: function (value) {
                    if (timer) clearTimeout(timer);
                    if (!this.isBusy) {
                      timer = setTimeout(() => {
                          this.getItems();
                      }, 500);
                    }
                }
            },

            value: {
                deep: true,
                handler: function (value) {
                    if (timer) clearTimeout(timer);
                    if (!this.isBusy) {
                      timer = setTimeout(() => {
                          this.currentPage = 1;
                          this.getItems();
                      }, 500);
                    }
                }
            }
        }
    }
</script>

<style>
  /* Absolute Center Spinner */
  .loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  /* Transparent Overlay */
  .loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
  }

  /* :not(:required) hides these rules from IE9 and below */
  .loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
  }

  .loading:not(:required):after {
    content: '';
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 1500ms infinite linear;
    -moz-animation: spinner 1500ms infinite linear;
    -ms-animation: spinner 1500ms infinite linear;
    -o-animation: spinner 1500ms infinite linear;
    animation: spinner 1500ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  }

  /* Animation */

  @-webkit-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-moz-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-o-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
